import { Directive, ElementRef, OnInit } from "@angular/core";

@Directive({
  selector: "[appRemovePageRange]",
  standalone: false,
})
export class RemovePageRangeDirective implements OnInit {
  constructor(private element: ElementRef) {}

  ngOnInit(): void {
    const el = this.element.nativeElement.querySelector(
      ".mat-paginator-range-label",
    ) as HTMLElement;
    el.className = `${el.className} current-page`;
  }
}
